import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LogoComponent } from '../core/tree/logo/logo.component';
import { DateHelper } from '../core/util/date.helper';
import { LanguageSwitchComponent } from '../shared/components/language-switch/language-switch.component';
import { SharedModule } from '../shared/shared.module';
import { MaintenanceService } from './maintenance.service';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SharedModule, LanguageSwitchComponent, LogoComponent],
})
export class MaintenanceComponent implements OnInit {
  private routerService = inject(Router);
  private maintenanceService = inject(MaintenanceService);

  until: string | null = null;

  ngOnInit(): void {
    /**
     * calls endpoint which is not accessible when maintenance mode is on
     * and which doesn't return 401 when called by not logged in user
     */
    this.maintenanceService.getPlan().subscribe({
      next: () => {
        this.routerService.navigate(['/sign-in']);
      },
      error: (error) => {
        const utcDate = error?.error?.until ?? null;

        this.until = DateHelper.convertUtcToIso(utcDate);
      },
    });
  }
}
